export const DepartColumnDefs = [
    {
        headerName: 'Room ID',
        field: 'room_id',
        minWidth: 150,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Department ID',
        field: 'department_id',
        minWidth: 150,
        flex: 1,
        hide: true,
        filter: false,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Thumbnail',
        field: 'thumbnail',
        minWidth: 102,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false
    },
    {
        headerName: 'Room Template Name',
        field: 'room_name',
        minWidth: 160,
        flex: 1,
        hide: false,
        filter: false,
        resizable: true,
        suppressMenu: true,
        cellStyle: { whiteSpace: 'normal'},
    },
    {
        headerName: '# Items',
        field: 'itemcount',
        minWidth: 81,
        hide: false,
        flex: 1,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
        cellStyle: { whiteSpace: 'normal'},
    },
    {
        headerName: 'Room Template Subtotal',
        field: 'budget',
        minWidth: 170,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
        sortable: false,
        cellStyle: { whiteSpace: 'normal' },
    },
    {
        headerName: 'Room Template Qty',
        field: 'quantity',
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true,
        flex: 1,
        suppressMenu: true,
        sortable: false,
        cellStyle: { whiteSpace: 'normal' },
    },
    {
        headerName: 'Room Template Total',
        field: 'exbudget',
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true,
        flex: 1,
        suppressMenu: true,
        sortable: false,
        cellStyle: { whiteSpace: 'normal' },
    },
    {
        headerName: 'Template Type',
        field: 'templatetype',
        minWidth: 115,
        hide: false,
        filter: false,
        resizable: true,
        flex: 1,
        suppressMenu: true,
        sortable: false,
        cellStyle: { whiteSpace: 'normal' },
    },
    {
        headerName: 'Department Template Name',
        field: 'department',
        minWidth: 192,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
        cellStyle: { whiteSpace: 'normal'},
    },
    {
        headerName: 'Create Date',
        field: 'creationdate',
        minWidth: 110,
        hide: false,
        flex: 1,
        filter: false,
        resizable: true,
        suppressMenu: true,
        sortable: false,
        cellStyle: { whiteSpace: 'normal'},
    },
];

export const RoomColumnDefs = [
    {
        field: '',
        headerCheckboxSelection: true,
        checkboxSelection: true,
        resizable: false,
        sortable: false,
        width: 60,
    },
    {
        headerName: 'Id',
        field: 'item_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'ProductId',
        field: 'product_id',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Thumbnail',
        field: 'images',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Model',
        field: 'model',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Category',
        field: 'category',
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true
    },
    {
        headerName: 'Subcategory',
        field: 'sub_category',
        minWidth: 150,
        hide: false,
        filter: false,
        resizable: true
    },
    {
        headerName: 'Item Description',
        field: 'Description',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        suppressMenu: true,
    },
    {
        headerName: 'Item QTY',
        field: 'quantity',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Unit Cost',
        field: 'list_price',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Total Cost',
        field: 'totalcost',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Template Type',
        field: 'templatetype',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Department Template Name',
        field: 'department',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Create Date',
        field: 'creationdate',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Manufacturer',
        field: 'manufacturer',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Vendor',
        field: 'vendor',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        suppressMenu: true,
    },
    {
        headerName: 'Catalog #',
        field: 'catalog',
        minWidth: 150,
        hide: false,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Numeric ID',
        field: 'bixpand_id',
        minWidth: 220,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Alphanumeric ID',
        field: 'cad_id',
        minWidth: 270,
        hide: false,
        filter: false,
        flex: 1,
        resizable: true,
    },
    {
        headerName: 'Custom ID 1',
        field: 'custom_id_1',
        minWidth: 220,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Custom ID 2',
        field: 'custom_id_2',
        minWidth: 270,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Govt. ID',
        field: 'govt_id',
        minWidth: 270,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
    },
    {
        headerName: 'Long Description',
        field: 'description',
        minWidth: 300,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Notes',
        field: 'notes',
        minWidth: 300,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Discontinued',
        field: 'discontinued',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Type',
        field: 'type',
        minWidth: 150,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Furnish Responsibility',
        field: 'furnish_responsibility',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Install Responsibility',
        field: 'install_responsibility',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Life Expectancy / Lifespan',
        field: 'life_expectancy',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Lead Time',
        field: 'lead_time',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Architectural Code',
        field: 'architectural_code',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Alternate ID',
        field: 'alternate_id',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Inventory ID',
        field: 'inventory_id',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Architecturally Significant',
        field: 'architecturally_significant',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Spatially Significant',
        field: 'spatially_significant',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Units',
        field: 'units',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Width',
        field: 'width',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Height',
        field: 'height',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Depth',
        field: 'depth',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Clearance - Left',
        field: 'clearance',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-left'
    },
    {
        headerName: 'Clearance - Right',
        field: 'clearance_right',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-right'
    },
    {
        headerName: 'Clearance - Back',
        field: 'clearance_back',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-back'
    },
    {
        headerName: 'Clearance - Front',
        field: 'clearance_front',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-front'
    },
    {
        headerName: 'Clearance - Top',
        field: 'clearance_top',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-top'
    },
    {
        headerName: 'Clearance - Bottom',
        field: 'clearance_bottom',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'clearance-bottom'
    },
    {
        headerName: 'Mouting',
        field: 'mouting',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Max Weight',
        field: 'max_weight',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Ship Weight',
        field: 'ship_weight',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Operating Weight',
        field: 'operating_weight',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'DA Complient',
        field: 'da_complient',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Antimicrobial',
        field: 'antimicrobial',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Green',
        field: 'green',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Shielding',
        field: 'Shielding',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Seismic',
        field: 'seismic',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Spatial Remarks',
        field: 'spatial_remarks',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        sortable: false,
        resizable: true
    },
    {
        headerName: 'Voltage Type',
        field: 'electrical_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'voltage_type'
    },
    {
        headerName: 'Volts',
        field: 'volts',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'volts'
    },
    {
        headerName: 'Amps',
        field: 'amps',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'amps'
    },
    {
        headerName: 'Watts',
        field: 'watts',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'watts'
    },
    {
        headerName: 'kVA',
        field: 'kva',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'kva'
    },
    {
        headerName: 'Hertz',
        field: 'hertz',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'hertz'
    },
    {
        headerName: 'Electric Phase',
        field: 'electric_phase',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'electric_phase'
    },
    {
        headerName: 'Plug Type',
        field: 'plug_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'plug_type'
    },
    {
        headerName: 'Plug Details',
        field: 'plug_details',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'plug_details'
    },
    {
        headerName: 'Emergency Power',
        field: 'emergency_power',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'emergency_power'
    },
    {
        headerName: 'Remote Transformer',
        field: 'remote_transformer',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'remote_transformer'
    },
    {
        headerName: 'Remote Switch / Controller',
        field: 'remote_switch',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'remote_switch'
    },
    {
        headerName: 'Electrical Remarks',
        field: 'electrical_remark',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'electrical_remark'
    },
    {
        headerName: 'Tech Connection',
        field: 'tech_connection_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'tech_connection'
    },
    {
        headerName: 'Connection Type',
        field: 'connection_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'connection_type'
    },
    {
        headerName: 'Network',
        field: 'network',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'network'
    },
    {
        headerName: 'Technical Remarks',
        field: 'technical_remarks',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'technical_remarks'
    },
    {
        headerName: 'Water Cold',
        field: 'plumbing_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'cold'
    },
    {
        headerName: 'Water Hot',
        field: 'hot',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'hot'
    },
    {
        headerName: 'Water Treated',
        field: 'treated',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'treated'
    },
    {
        headerName: 'Steam',
        field: 'steam',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'steam'
    },
    {
        headerName: 'Medical Vaccum',
        field: 'medical_vaccum',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'medical_vaccum'
    },
    {
        headerName: 'Dental Vaccum',
        field: 'dental_vaccum',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'dental_vaccum',
        cellRenderer: (params) => {
            if (params?.data) {
                return (
                    <span>{params?.data?.plumbing_data?.vaccumDental ? 'Yes' : 'No'}</span>
                );
            }
            return '';
        },
    },
    {
        headerName: 'Medical Gas',
        field: 'medical_gas',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'medical_gas'
    },
    {
        headerName: 'Drain',
        field: 'drain',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'drain'
    },
    {
        headerName: 'Drain Location',
        field: 'drain_location',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'drain_location'
    },
    {
        headerName: 'Gas Type',
        field: 'gas_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'gas_type'
    },
    {
        headerName: 'Gas Location',
        field: 'gas_location',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'gas_location'
    },
    {
        headerName: 'Plumbing Remarks',
        field: 'plumbing_remarks',
        minWidth: 200,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'plumbing_remarks'
    },
    {
        headerName: 'Vent',
        field: 'mechanical_data',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'vent'
    },
    {
        headerName: 'Vent Type',
        field: 'vent_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'vent_type'
    },
    {
        headerName: 'Heat Dissipation (BTU/hr)',
        field: 'heat_hr',
        minWidth: 200,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'heat_hr'
    },
    {
        headerName: 'Dissipation Type',
        field: 'dissipation_type',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'dissipation_type'
    },
    {
        headerName: 'Mechanical Remarks',
        field: 'mechanical_remarks',
        minWidth: 180,
        hide: true,
        filter: false,
        flex: 1,
        resizable: true,
        sortable: false,
        colId: 'mechanical_remarks'
    },
];